import React, { ReactNode } from "react";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty";
import { useTranslations } from "next-intl";
import { ShoppingCartIcon } from "lucide-react";
const AppEmpty = ({
  title,
  description,
  children,
  icon = <ShoppingCartIcon />,
}: {
  title: string;
  description: string;
  children?: ReactNode;
  icon?: ReactNode;
}) => {
  const t = useTranslations();
  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">{icon}</EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>{children}</EmptyContent>
    </Empty>
  );
};

export default AppEmpty;
